import PropTypes from 'prop-types'
import React from 'react'
import generateJSX from 'src/utils/generateJSX'
import { media } from 'src/styles/styled-components'
import styled from 'styled-components'

const StyledContainer = styled.div`
  h1, 
  h2 {
    font-weight: ${ p => p.theme.fontWeight.primary.Medium };
    line-height: 1.17;
    /* ${ media.mobile`
      letter-spacing: 0.01em;
      ` } */
  }
  h1 {
    font-size: 2.4rem;
    margin-bottom: 30px;
    ${ media.tablet`
      font-size: 2.8rem;
      overflow-wrap: break-word;
    ` }
  }
  h2 {
    font-size: 2.2rem;
    margin-bottom: 30px;
    overflow-wrap: break-word;
    ${ media.tablet`
      font-size: 2.4rem;
    ` }
  
  }
  p {
    font-size: 1.8rem;
    font-weight: ${ p => p.theme.fontWeight.primary.Light };
    letter-spacing: 0.01em;
    line-height: 1.55;
    margin-bottom: 30px;
    overflow-wrap: break-word;
  }
  i {
    font-style: italic;
    overflow-wrap: break-word;
  }
  b {
    font-weight: ${ ({ theme }) => theme.fontWeight.primary.Bold };
    overflow-wrap: break-word;
  }
  a {
    color: ${ p => p.theme.colors.red };
    overflow-wrap: break-word;
    text-decoration: underline;
  }
  blockquote {
    font-family: ${ p => p.theme.font.secondary };
    margin-bottom: 30px;
    overflow-wrap: break-word;
    padding: 5px 0 5px 10px;
    font-size: 1.4rem;
    background-color: #FAFAFA;
    padding: 30px;
    position: relative;
    &:after {
      content: '“';
      position: absolute;
      left: -28px;
      top: 50px;
      font-size: 75px;
      font-style: italic;
      color: ${ p => p.theme.colors.purple }
    }
    ${ media.tablet`
      font-size: 1.8rem;
      padding: 50px;
    ` }
    p {
      margin-bottom: 25px;
    }
    b {
      font-size: 1.5rem
    }
  }
  ul {
    margin-bottom: 30px;
    list-style: disc;
    list-style-position: inside;
    li {
      margin-bottom: 10px;
      p {
        display: inline;
      }
    }
  }
  ol {
    list-style: decimal;
    padding-left: 20px;
    li {
      &::marker {
        font-weight: ${ p => p.theme.fontWeight.primary.Light };
      }
      p {
        margin-bottom: 10px;
      }
    }
  }
  strong {
    font-weight: ${ ({ theme }) => theme.fontWeight.primary.Bold };

    &.nowrap {
      white-space: nowrap;
    }
  }
  .blogImage {
    display: block;
    margin: 0 auto;
  }
`

class ArTextContent extends React.Component {
  static propTypes = {
    content: PropTypes.array,
  }

  render () {
    return this.props.contentHTML
      ? <StyledContainer {...this.props} dangerouslySetInnerHTML={{ __html: this.props.contentHTML }}></StyledContainer>
      : <StyledContainer {...this.props}>{generateJSX(this.props.content)}</StyledContainer>
  }
}

export default ArTextContent
